import { useEffect } from 'react';
import Hero from './components/Hero';
import CompanyOverview from './components/CompanyOverview';
import Products from './components/Products';
import Technology from './components/Technology';
import Team from './components/Team';
import Vision from './components/Vision';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  useEffect(() => {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <CompanyOverview />
      <Products />
      <Technology />
      <Team />
      <Vision />
      <Footer />
    </div>
  );
}
